import { WorkingTimeImportStatus } from "@/orval/gen"
import { DefaultMantineColor } from "@mantine/core"
import { match } from "ts-pattern"

export function getWorkingTimeImportStatusColor(
  status: WorkingTimeImportStatus
): DefaultMantineColor | undefined {
  return match<WorkingTimeImportStatus, DefaultMantineColor | undefined>(status)
    .with("Failed", "Rejected", () => "red.4")
    .with("Approved", () => "green.4")
    .with("Requested", () => "yellow.4")
    .otherwise(() => undefined)
}
